import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import LoadableButton from "../../components/button/LoadableButton";
import { CheckBaseUrlApi, LoginApi } from "../../api/request/auth";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../store/Slices/userSlice";
// import { setCookies } from '../../services/Cookies';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.user.userDetails);

  const [form] = Form.useForm();

  const [initialValues, setInitialValues] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    const params = {
      ...values,
    };
    try {
      setIsLoading(true);
      const { data } = await LoginApi(params);
      if (data?.status) {
        form.resetFields();
        localStorage.setItem("email", values?.email);
        toast.success(data?.message);
        navigate("/otp");
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false);
    }
  };

  const checkBaseUrl = async () => {
    try {
      const { data } = await CheckBaseUrlApi();
      if (data?.status) {
        dispatch(setUserDetails({ base_url: data?.base_url }));
      }
    } catch (error) {
      console.error("Error fetching base URL:", error);
    }
  };

  useEffect(() => {
    checkBaseUrl();
  }, []);

  return (
    <>
      <div className="lg:w-3/5 md:w-[80%] w-full sm:p-0 p-4">
        <Form
          layout="vertical"
          autoComplete="off"
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues}
          className="space-y-7"
        >
          <p className="sm:text-3xl text-2xl text-center font-bold">
            Login to <span className="text-primary">Trackmydoc</span>
          </p>
          <Form.Item
            label={<p className="font-semibold">Email</p>}
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please input valid email!" },
            ]}
          >
            <Input placeholder="Email address" size="large" />
          </Form.Item>
          <Form.Item
            label={
              <div className="flex">
                <p className="font-semibold">Password</p>
              </div>
            }
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              placeholder="Password"
              size="large"
              className="col-span-2"
            />
          </Form.Item>
          <div
            style={{ marginTop: "4px" }}
            className="text-primary cursor-pointer text-right"
          >
            <Link to="/forget_password">Forgot Password</Link>
          </div>

          <LoadableButton
            type="submit"
            isLoading={isLoading}
            lable="Login"
            loadingLable="Verifying..."
            img="assets/icons/ArrowRight.svg"
            className="btn-primary text-white text-base w-full py-2 rounded-md mb-5 flex justify-center items-center"
          />

          {/* <div className="flex items-center mb-5">
                        <hr className="flex-grow" />
                        <span className="mx-2 text-Gray">OR LOGIN WITH</span>
                        <hr className="flex-grow" />
                    </div>
                    <div className='flex lg:flex-row flex-col justify-center items-center lg:px-5 lg:space-y-0 space-y-2'>
                        <button type="button" className='border rounded-lg flex items-center justify-center py-2 w-full lg:me-3'>
                            <img src='assets/icons/google.svg' alt='icon' className='me-1' />
                            Sign in with Google
                        </button>
                        <button type="button" className='border rounded-lg flex items-center justify-center py-2 w-full'>
                            <img src='assets/icons/facebook.svg' alt='icon' className='me-1' />
                            Sign in with Facebook
                        </button>
                    </div>
                    <p className='text-center  mt-5'>Not registered yet ? <Link to='/register' className='text-primary cursor-pointer'>Create an account</Link></p> */}
        </Form>
      </div>
    </>
  );
};

export default Login;
